 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g shadow-type-5 [height]="height()"></g>
        <g wall-type-5 [height]="height()"></g>
        
        <g roof-type-5/>
        <g outline />
        <g window-type-5 [height]="height()"/>
        <g foundation-type-2/>
</svg>